import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { filterSurveyDetail } from 'redux/survey/surevey-detail';

function useGetData(open,surveyId,pageTable) {
   const dispatch=useDispatch()
   useEffect(()=>{
    if(!open) return 
    dispatch(
     filterSurveyDetail({
        surveyId,
        pageSize: 10,
        pageNumber: pageTable,
     })as any)
   },[open,pageTable])
}

export default useGetData